// Single source of truth for WhatsApp + phone + business address.
export const WA_NUMBER = "919886473926"; // +91 98864 73926
export const PHONE_DISPLAY = "+91 98864 73926";
export const PHONE_TEL = "+919886473926";

export const BUSINESS_ADDRESS = {
  line1: "Unit 101, Oxford Tower",
  line2: "139 Old Airport Road, Kodihalli",
  line3: "HAL II Stage, Bangalore 560008",
  line4: "Karnataka, India",
  full: "Unit 101, Oxford Tower, 139 Old Airport Road, Kodihalli, HAL II Stage, Bangalore 560008, Karnataka, India",
};

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;

// Brand line shared across WhatsApp greetings and the OG share card.
export const BRAND_TAGLINE =
  "Transform at home with Yogasana · Pranayama · Meditation · Nutrition · Lifelong Habit Mastery.";
export const SOCIAL_PROOF_LINE =
  "Join hundreds who unlocked their dream physique.";

const open = (intent) =>
  `Hi Dhruva — ${intent}\n\nWeight Loss Gurukul · Ancient Wisdom – Real Transformation\n${BRAND_TAGLINE}\n${SOCIAL_PROOF_LINE}`;

export const WA_MESSAGES = {
  general: open("I'd like to know more about Weight Loss Gurukul."),
  trial: open("I'd like to book my free consultation."),
  starter: open("I'd like to start the 7-Day Transformation Starter (complimentary)."),
  alchemy: open("I'd like details on the 90-Day Inner Alchemy Challenge."),
  vip: open("I'd like details on the VIP 1-Year Total Transform Challenge."),
  weightLoss: open("I want to start a weight-loss transformation program."),
  detox: open("I'd like details on the detox journey."),
  pcos: open("I'd like details on women's wellness programs."),
  wellness: open("I'd like to know about general wellness coaching."),
  program: (title) => open(`I'm interested in the "${title}" program — please share details.`),
};
